import { IClientData } from "../../../models/ClientData";

type IUserFirstIntent = string;

export function factClientFirstIntent(
  data: IClientData | null
): IUserFirstIntent {
  // use tracking data from client to map more specific intents when  more than annuity journey in portal
  return "advised-annuity-calculator";
}
